import comp from "./CoachMarks";
export default comp;
